import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DateTime } from 'luxon';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import DashboardSearchCriteria from 'src/app/interfaces/dashboardSearchCriteria';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent {
    isLoading = true;
    companyType: string = '';
    userProfile: UserProfile | undefined;
    isOnProbation: boolean = false;
    probationStartDate?: string;
    probationEndDate?: string;
    probationModalDismissed: boolean = false;
    canRequestRecords: boolean = false;
    mustAcknowledgeAudit: boolean = false;
    isAuditAcknowledgeBypassed: boolean = false;
    isAuditAcknowledged: boolean = false;
    searchCriteria: DashboardSearchCriteria = { searchString: '', pageSize: 10 };

    @ViewChild('ProbationModal')
    probationModal!: TemplateRef<any>;
  

    constructor(
                private authenticationService: AuthenticationService,
                public generalService: GeneralService, 
                private router: Router,
                public modalService: NgbModal) 
      {
        if(!authenticationService.isDeeplinkResolved()){
            const deepLink = authenticationService.getDeepLink();
            if (deepLink) {
                window.location.href = deepLink;
            }
        }

        // CSRs are forbidden from accessing the dashboard
        const roles = authenticationService.getRoles();
        const isCsr = roles && roles.includes('csr_user');
        if(isCsr) {
          router.navigate(['/accessDenied']);
        }
      }

      send(searchCriteria: DashboardSearchCriteria) {
        this.searchCriteria = searchCriteria;
      }
    
     ngOnInit(): void {
          if (!this.userProfile){
               this.userProfile = this.authenticationService.getUserProfile() as any;
               console.log(this.userProfile)
          }
          
          if (this.userProfile && this.userProfile.customer && this.userProfile.customer.auditCustomerStatus?.toLocaleLowerCase() === 'probation'
               && this.userProfile!.customer!.auditPenalty!.penaltyStartDate && this.userProfile!.customer!.auditPenalty!.penaltyEndDate) {
               const start = DateTime.fromISO(this.userProfile!.customer!.auditPenalty!.penaltyStartDate.toString());
               const end = DateTime.fromISO(this.userProfile!.customer!.auditPenalty!.penaltyEndDate.toString());
               if (this.userProfile!.customer!.auditPenalty!.auditPenaltyActionId === 1 &&
                    start <= DateTime.now() && end >= DateTime.now()
               ) {
                    this.isOnProbation = true;
                    this.probationStartDate = start.toLocaleString();
                    this.probationEndDate = end.toLocaleString();
               }
          }

          this.canRequestRecords = (this.authenticationService.getRoles() !== null && this.authenticationService.getRoles().includes('mc_request'));

          this.setAuditAcknowledgementState();

          if (this.mustAcknowledgeAudit && !this.isAuditAcknowledgeBypassed && !this.isAuditAcknowledged) {
               this.router.navigateByUrl('/auditAcknowledgement');
          }

          this.isLoading = false;
     }

    ngAfterViewInit(){
      if(this.isOnProbation && !(this.mustAcknowledgeAudit && !this.isAuditAcknowledgeBypassed && !this.isAuditAcknowledged ) ){
                  // wait 1 second then show probation modal
        setTimeout(() => {
            this.modalService.open(this.probationModal, { ariaLabelledBy: 'probationModalTitle' });
        }, 1000);
      }
    }
    
    setAuditAcknowledgementState() {
        const userProfile = this.authenticationService.getUserProfile() as any;
        this.isAuditAcknowledgeBypassed = this.authenticationService.isAuditAcknowledgeBypassed();
        this.isAuditAcknowledged = this.authenticationService.isAuditAcknowledged();
        if (userProfile && userProfile.customer && userProfile.customer.auditCustomer && userProfile.customer.auditCustomer !== null) {
            if (userProfile.customer.auditCustomer.AuditAcknowledgeDate
                && userProfile.customer.auditCustomer.AuditAcknowledgeDate === null
                && userProfile.customer.auditCustomer.auditCustomerStatusId === 1)
            {
                this.mustAcknowledgeAudit = true;
            } else {
                const auditAckDate = DateTime.fromISO(userProfile!.customer!.auditCustomer!.AuditAcknowledgeDate);
                const minDate = DateTime.fromFormat('01/01/2022', 'MM/dd/yyyy');
                const isAcknowledgedDate = auditAckDate.isValid && auditAckDate > minDate;
                const isInAudit = userProfile!.customer!.auditCustomer!.auditCustomerStatusId === 1;
                this.mustAcknowledgeAudit = isInAudit && !isAcknowledgedDate;
            }
        } else {
            this.mustAcknowledgeAudit = false;
        }
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    }

    dismissProbationModal() {
        this.probationModalDismissed = true;
        this.modalService.dismissAll();
    }

}
